/* Stories Flooring – Floor Finder ("Your floor story")
 * Reads live product data (metafields) from sections/floor-finder-data.liquid via the
 * Section Rendering API and walks the shopper through six questions.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-floor-finder]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-ff-config]').textContent); } catch (e) {}
  var WASTAGE = (Number(cfg.wastage) || 0) / 100;
  var PAGE_SIZE = Number(cfg.showAll) || 12;
  var STORE_KEY = 'sf_floor_finder_state_v2';
  var FEED_KEY = 'sf_floor_finder_feed_v2';
  var FEED_TTL = 15 * 60 * 1000;
  var LEAVE_MS = 240;
  var AUTO_MS = 420;

  var main = root.querySelector('[data-ff-main]');
  var stepsEl = root.querySelector('[data-ff-steps]');
  var restartBtn = root.querySelector('[data-ff-restart]');
  var toastEl = root.querySelector('[data-ff-toast]');

  /* ------------------------------------------------------------------ */
  /* Option definitions – map shopper language onto metafield values     */
  /* ------------------------------------------------------------------ */
  var ROOMS = [
    { k: 'living-room', label: 'Living room', sub: 'Statement · Comfortable', match: ['Living Room', 'Lounge'] },
    { k: 'kitchen', label: 'Kitchen', sub: 'Spill-proof · Hard-wearing', match: ['Kitchen'] },
    { k: 'bathroom', label: 'Bathroom', sub: 'Water-resistant · Practical', match: ['Bathroom'] },
    { k: 'bedroom', label: 'Bedroom', sub: 'Warm · Quiet', match: ['Bedroom'] },
    { k: 'hallway', label: 'Hallway', sub: 'High-traffic', match: ['Hallway'] },
    { k: 'dining-room', label: 'Dining room', sub: 'Chair-proof · Easy-clean', match: ['Dining Room'] },
    { k: 'office', label: 'Home office', sub: 'Durable · Chair-friendly', match: ['Office'] },
    { k: 'conservatory', label: 'Conservatory', sub: 'Light-stable · Versatile', match: ['Conservatory'] }
  ];

  var TYPES = [
    { k: 'LVT', label: 'Luxury vinyl (LVT)', sub: 'Waterproof · warm · quiet underfoot' },
    { k: 'SPC', label: 'Rigid core (SPC)', sub: '100% waterproof · rigid click-fit' },
    { k: 'Laminate', label: 'Laminate', sub: 'Scratch-resistant · great value' },
    { k: 'Engineered Wood', label: 'Engineered wood', sub: 'Real wood top · UFH friendly' },
    { k: 'Solid Wood', label: 'Solid wood', sub: 'Timeless · can be re-sanded' }
  ];

  var DESIGNS = [
    { k: 'plank', label: 'Plank', sub: 'Classic long boards' },
    { k: 'herringbone', label: 'Herringbone', sub: 'Classic zigzag pattern' },
    { k: 'chevron', label: 'Chevron', sub: 'Crisp V-shaped pattern' },
    { k: 'basketweave', label: 'Basket weave', sub: 'Woven parquet blocks' },
    { k: 'versailles', label: 'Versailles', sub: 'Grand French panels' },
    { k: 'tile', label: 'Stone & tile', sub: 'Stone and tile effects' }
  ];

  var SHADES = [
    { k: 'light', label: 'Light', sub: 'Blonde, white & natural oak' },
    { k: 'medium', label: 'Medium', sub: 'Honey, golden & classic oak' },
    { k: 'dark', label: 'Dark', sub: 'Walnut, smoked & deep tones' },
    { k: 'grey', label: 'Grey', sub: 'Grey, ash & cool tones' }
  ];

  var BUDGETS = [
    { k: 'b1', min: 0, max: 20 },
    { k: 'b2', min: 20, max: 35 },
    { k: 'b3', min: 35, max: 50 },
    { k: 'b4', min: 50, max: Infinity }
  ];

  var PURPOSES = [
    { k: 'update', label: 'To update the look of my room', sub: 'Refresh the style' },
    { k: 'damaged', label: 'To replace a worn or damaged floor', sub: 'Something built to last' },
    { k: 'moving', label: 'Moving into a new home', sub: 'Great value for a new property' },
    { k: 'noise', label: 'To reduce noise', sub: 'Quieter, softer underfoot' },
    { k: 'clean', label: 'Something easier to clean', sub: 'Kids, pets & spills' },
    { k: 'browsing', label: 'Just browsing for ideas', sub: 'Show me a good mix' }
  ];

  var STEPS = [
    { id: 'room', short: 'Room', title: 'Where is the new floor going?', sub: "We'll match performance to the room – water-resistant for bathrooms, tough for hallways, warm for bedrooms." },
    { id: 'type', short: 'Type', title: 'What kind of flooring do you prefer?', sub: 'Choose the type you have in mind – or leave it to us. We only show types that suit your room.' },
    { id: 'budget', short: 'Size & budget', title: 'Your room size & budget', sub: "Pop in your room size and we'll show budgets as a real total for your floor, wastage included." },
    { id: 'pattern', short: 'Pattern', title: 'Which pattern do you love?', sub: 'Choose as many as you like – from classic planks to herringbone and chevron.' },
    { id: 'shade', short: 'Colour', title: 'Which tones feel like home?', sub: "Pick a palette and we'll match the shades – or leave it to us." },
    { id: 'purpose', short: 'Purpose', title: "What's brought you here today?", sub: "This helps us rank your matches – it won't limit your results." }
  ];

  // Single-choice questions move on by themselves; multi-choice wait for "Continue"
  var MULTI = { pattern: 1, shade: 1 };
  var AUTO = { room: 1, type: 1, purpose: 1 };

  /* ------------------------------------------------------------------ */
  /* State                                                               */
  /* ------------------------------------------------------------------ */
  function blankState() {
    return { step: 0, view: 'quiz', room: null, type: [], width: '', length: '', sizeMode: 'dims', area: '', budget: null, pattern: [], shade: [], purpose: null, shown: PAGE_SIZE };
  }
  var state = blankState();
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    if (saved && typeof saved === 'object') state = Object.assign(blankState(), saved);
  } catch (e) {}

  // Deep links: /pages/floor-finder?room=kitchen
  try {
    var params = new URLSearchParams(location.search);
    var qRoom = params.get('room');
    if (qRoom && ROOMS.some(function (r) { return r.k === qRoom; })) {
      state = blankState();
      state.room = qRoom;
      state.step = 1;
      if (history.replaceState) history.replaceState(null, '', location.pathname);
    }
  } catch (e) {}

  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  var products = [];
  var busy = false;

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(s) { var n = parseFloat(String(s == null ? '' : s).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; }
  function money(n, dp) {
    if (dp == null) dp = 2;
    return '£' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }
  function roundNice(n) { return n >= 1000 ? Math.round(n / 50) * 50 : Math.round(n / 10) * 10; }
  function img(url, w) { return url ? (/width=\d+/.test(url) ? String(url).replace(/width=\d+/, 'width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w) : ''; }
  function area() {
    if (state.sizeMode === 'area') { var t = num(state.area); return t > 0 ? Math.round(t * 100) / 100 : 0; }
    var w = num(state.width), l = num(state.length);
    return w > 0 && l > 0 ? Math.round(w * l * 100) / 100 : 0;
  }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }
  function byKey(list, k) { for (var i = 0; i < list.length; i++) if (list[i].k === k) return list[i]; return null; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function designKey(d) {
    d = String(d || '').toLowerCase();
    if (!d) return null;
    if (d.indexOf('herringbone') > -1 || d === 'parquet') return 'herringbone';
    if (d.indexOf('chevron') > -1) return 'chevron';
    if (d.indexOf('basket') > -1) return 'basketweave';
    if (d.indexOf('versailles') > -1) return 'versailles';
    if (d.indexOf('tile') > -1 || d.indexOf('stone') > -1) return 'tile';
    if (d.indexOf('plank') > -1) return 'plank';
    return null;
  }
  function shadeKey(s, colour) {
    s = String(s || colour || '').toLowerCase();
    if (!s) return null;
    if (s.indexOf('grey') > -1 || s.indexOf('gray') > -1) return 'grey';
    if (s.indexOf('light') > -1 || s.indexOf('white') > -1 || s.indexOf('natural') > -1 || s.indexOf('beige') > -1) return 'light';
    if (s.indexOf('dark') > -1 || s.indexOf('black') > -1 || s.indexOf('coffee') > -1) return 'dark';
    if (s.indexOf('medium') > -1 || s.indexOf('brown') > -1 || s.indexOf('golden') > -1) return 'medium';
    return null;
  }
  function yes(v) { return /^(yes|true|suitable|1)/i.test(String(v || '')); }

  function prepare(raw) {
    var out = [];
    raw.forEach(function (p, idx) {
      if (!p || !p.av) return;
      if (p.hide === true || yes(p.off) || yes(p.dis)) return;
      if (p.dl) return; // has a "Variant Delivery" date – not available to buy right now
      if (String(p.sm || '').toLowerCase() === 'box') return; // job lots / bundles
      var pack = num(p.pk);
      var price = Number(p.pr) / 100;
      if (!price || !pack) return;
      var rooms = Array.isArray(p.rm) ? p.rm : (p.rm ? [p.rm] : []);
      var roomKeys = ROOMS.filter(function (r) { return r.match.some(function (m) { return rooms.indexOf(m) > -1; }); }).map(function (r) { return r.k; });
      if (!roomKeys.length) return;
      out.push({
        id: p.id, url: p.u, title: p.t, vendor: p.vn, type: p.ty, range: p.rg || p.vn,
        floor: p.fl || p.i, floorSure: !!p.fs, room: p.rs || null,
        rooms: roomKeys,
        design: designKey(p.de), designRaw: p.de,
        shade: shadeKey(p.sh, p.co), shadeRaw: p.sh || p.co,
        pack: pack, price: price,
        compare: p.cp ? Number(p.cp) / 100 : 0,
        ppm: price / pack,
        cppm: p.cp ? (Number(p.cp) / 100) / pack : 0,
        wear: p.wl, ufh: yes(p.uf), water: yes(p.wr) || p.ty === 'SPC', underlay: yes(p.ul), warranty: p.wa,
        rating: num(p.rt), ratingCount: Number(p.rc) || 0, pet: !!p.pet,
        sample: p.smp ? Math.round(Number(p.smp)) : 0,
        thickness: p.th, width: p.wd, length: p.ln,
        rank: idx
      });
    });
    var n = out.length || 1;
    out.forEach(function (p) { p.pop = 1 - p.rank / n; });
    return out;
  }

  /* ------------------------------------------------------------------ */
  /* Data                                                                */
  /* ------------------------------------------------------------------ */
  function fetchPage(n) {
    var url = cfg.feedUrl + '?section_id=' + encodeURIComponent(cfg.feedSection) + '&sort_by=best-selling&page=' + n;
    var th = window.Shopify && window.Shopify.theme;
    if (th && th.role && th.role !== 'main' && th.id) url += '&preview_theme_id=' + th.id;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Feed ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('[data-ff-feed]');
      if (!node) throw new Error('Feed missing');
      return JSON.parse(node.textContent);
    });
  }

  function loadFeed() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(FEED_KEY) || 'null');
      if (cached && Date.now() - cached.t < FEED_TTL && cached.items && cached.items.length) return Promise.resolve(cached.items);
    } catch (e) {}
    return fetchPage(1).then(function (first) {
      var pages = Number(first.pages) || 1;
      var jobs = [];
      for (var i = 2; i <= pages; i++) jobs.push(fetchPage(i));
      return Promise.all(jobs).then(function (rest) {
        var items = first.items.slice();
        rest.forEach(function (r) { items = items.concat(r.items || []); });
        try { sessionStorage.setItem(FEED_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Filtering                                                           */
  /* ------------------------------------------------------------------ */
  function anyOf(arr) { return !arr || !arr.length || arr.indexOf('any') > -1; }
  function budgetOk(p, k) {
    var b = byKey(BUDGETS, k);
    return !b || (p.ppm >= b.min && p.ppm < b.max);
  }
  function passes(p, stepId) {
    switch (stepId) {
      case 'room': return !state.room || p.rooms.indexOf(state.room) > -1;
      case 'type': return anyOf(state.type) || state.type.indexOf(p.type) > -1;
      case 'budget': return !state.budget || state.budget === 'any' || budgetOk(p, state.budget);
      case 'pattern': return anyOf(state.pattern) || state.pattern.indexOf(p.design) > -1;
      case 'shade': return anyOf(state.shade) || state.shade.indexOf(p.shade) > -1;
      default: return true;
    }
  }
  // Products that satisfy every answered step before `idx`
  function poolBefore(idx) {
    var ids = STEPS.slice(0, idx).map(function (s) { return s.id; });
    return products.filter(function (p) { return ids.every(function (id) { return passes(p, id); }); });
  }
  function finalPool() { return poolBefore(STEPS.length); }

  function countFor(pool, stepId, key) {
    return pool.filter(function (p) {
      switch (stepId) {
        case 'room': return p.rooms.indexOf(key) > -1;
        case 'type': return p.type === key;
        case 'budget': return budgetOk(p, key);
        case 'pattern': return p.design === key;
        case 'shade': return p.shade === key;
      }
      return true;
    }).length;
  }

  // Drop answers that no longer have products after an earlier answer changes
  function reconcile() {
    if (state.type.length > 1) state.type = state.type.slice(0, 1);
    for (var i = 1; i < STEPS.length; i++) {
      var id = STEPS[i].id;
      var pool = poolBefore(i);
      if (id === 'type' || id === 'pattern' || id === 'shade') {
        state[id] = state[id].filter(function (k) { return k === 'any' || countFor(pool, id, k) > 0; });
      }
      if (id === 'budget' && state.budget && state.budget !== 'any' && countFor(pool, 'budget', state.budget) === 0) state.budget = null;
    }
  }

  function answered(stepId) {
    switch (stepId) {
      case 'room': return !!state.room;
      case 'type': return state.type.length > 0;
      case 'budget': return !!state.budget;
      case 'pattern': return state.pattern.length > 0;
      case 'shade': return state.shade.length > 0;
      case 'purpose': return !!state.purpose;
    }
    return false;
  }

  function isSelected(stepId, value) {
    var v = state[stepId];
    return Array.isArray(v) ? v.indexOf(value) > -1 : v === value;
  }

  function answerLabel(stepId) {
    var a = area();
    switch (stepId) {
      case 'room': var r = byKey(ROOMS, state.room); return r ? r.label : '';
      case 'type': return anyOf(state.type) ? (state.type.length ? 'Any type' : '') : state.type.map(function (k) { return byKey(TYPES, k).label; }).join(', ');
      case 'budget':
        if (!state.budget) return '';
        var lbl = state.budget === 'any' ? 'Any budget' : budgetText(byKey(BUDGETS, state.budget), a).main;
        return (a ? a + ' m² · ' : '') + lbl;
      case 'pattern': return anyOf(state.pattern) ? (state.pattern.length ? 'Any pattern' : '') : state.pattern.map(function (k) { return byKey(DESIGNS, k).label; }).join(', ');
      case 'shade': return anyOf(state.shade) ? (state.shade.length ? 'Not sure' : '') : state.shade.map(function (k) { return byKey(SHADES, k).label; }).join(', ');
      case 'purpose': var pu = byKey(PURPOSES, state.purpose); return pu ? pu.label : '';
    }
    return '';
  }

  function budgetText(b, a) {
    if (!b) return { main: '', sub: '' };
    var perM = b.max === Infinity ? money(b.min, 0) + '+/m²' : (b.min === 0 ? 'Up to ' + money(b.max, 0) + '/m²' : money(b.min, 0) + ' – ' + money(b.max, 0) + '/m²');
    if (!a) return { main: perM, sub: '' };
    var lo = roundNice(b.min * a), hi = roundNice(b.max * a);
    var main = b.max === Infinity ? money(lo, 0) + '+' : (b.min === 0 ? 'Up to ' + money(hi, 0) : money(lo, 0) + ' – ' + money(hi, 0));
    return { main: main, sub: perM };
  }

  /* ------------------------------------------------------------------ */
  /* Ranking                                                             */
  /* ------------------------------------------------------------------ */
  function score(p) {
    var s = p.pop * 40;
    if (p.ratingCount) s += Math.min(10, Math.log(1 + p.ratingCount) * 2) * (p.rating / 5);
    if (p.compare > p.price) s += 4;
    var wet = state.room === 'bathroom' || state.room === 'kitchen';
    if (wet && p.water) s += 8;
    if (state.room === 'hallway' && num(p.wear) >= 0.55) s += 4;
    switch (state.purpose) {
      case 'noise': if (p.underlay) s += 14; if (p.type === 'LVT' || p.type === 'SPC') s += 4; break;
      case 'clean': if (p.water) s += 10; if (p.pet) s += 6; if (p.type === 'LVT' || p.type === 'SPC') s += 4; break;
      case 'damaged': s += Math.min(10, num(p.wear) * 12); if (num(p.warranty)) s += Math.min(6, num(p.warranty) / 5); break;
      case 'moving':
        var pool = finalPool(), maxP = Math.max.apply(null, pool.map(function (x) { return x.ppm; }).concat([1]));
        s += 12 * (1 - p.ppm / maxP); break;
      case 'update': if (p.compare > p.price) s += 4; s += p.pop * 6; break;
    }
    return s;
  }

  // Ranges Stories wants to push in the results, per flooring type (matched against the product's range)
  var PRIORITY = {
    'LVT': ['harbour', 'coastal', 'village', 'courtyard', 'portofino glue down'],
    'Engineered Wood': ['uniqo'],
    'SPC': ['brescia']
  };
  function isPriority(p) {
    var list = PRIORITY[p.type] || [];
    var r = String(p.range || '').toLowerCase();
    return list.some(function (k) { return r.indexOf(k) > -1; });
  }

  // Results order: the genuine best match first, then the shortlist and the full list mix the
  // priority ranges in among the other floors (P, O, P, P, O ...) so they sit high up without
  // looking like a block. Every floor still has to pass all of the shopper's answers.
  function ranked() {
    var list = finalPool().map(function (p) { return { p: p, s: score(p) }; })
      .sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.p; });
    if (!list.length) return list;
    var hero = list[0];
    var rest0 = list.slice(1);
    // Priority floors: take turns between ranges so one range never fills a whole row
    var byRange = {}, order = [];
    rest0.filter(isPriority).forEach(function (p) {
      if (!byRange[p.range]) { byRange[p.range] = []; order.push(p.range); }
      byRange[p.range].push(p);
    });
    var pri = [];
    for (var more = true; more;) {
      more = false;
      order.forEach(function (r) { if (byRange[r].length) { pri.push(byRange[r].shift()); more = true; } });
    }
    var oth = rest0.filter(function (p) { return !isPriority(p); });
    var mixed = [], pattern = ['P', 'O', 'P'], k = 0;
    while (pri.length || oth.length) {
      var want = pattern[k % pattern.length]; k++;
      if (want === 'P' && pri.length) mixed.push(pri.shift());
      else if (want === 'O' && oth.length) mixed.push(oth.shift());
      else mixed.push(pri.length ? pri.shift() : oth.shift());
    }
    // Shortlist: make sure every pattern / colour the shopper picked is represented
    var top = [hero], used = {}, seenRange = {};
    used[hero.id] = 1; seenRange[hero.range] = 1;
    function take(fn) {
      for (var i = 0; i < mixed.length; i++) {
        var p = mixed[i];
        if (!used[p.id] && fn(p)) { used[p.id] = 1; top.push(p); seenRange[p.range] = 1; return true; }
      }
      return false;
    }
    var pats = anyOf(state.pattern) ? [null] : state.pattern;
    var shs = anyOf(state.shade) ? [null] : state.shade;
    var groups = [];
    pats.forEach(function (pa) { shs.forEach(function (sh) { groups.push({ pa: pa, sh: sh }); }); });
    if (groups.length > 1) {
      groups.forEach(function (g) {
        if (top.length >= 4) return;
        var fits = function (p) { return (!g.pa || p.design === g.pa) && (!g.sh || p.shade === g.sh); };
        if (top.some(fits)) return;
        take(function (p) { return fits(p) && !seenRange[p.range]; }) || take(fits);
      });
    }
    while (top.length < 4 && take(function (p) { return isPriority(p) || !seenRange[p.range]; })) {}
    while (top.length < 4 && take(function () { return true; })) {}
    // Keep the shortlist cards in the mixed order so the pushed ranges sit in between the others
    var shortlist = top.slice(1).sort(function (a, b) { return mixed.indexOf(a) - mixed.indexOf(b); });
    return [hero].concat(shortlist, mixed.filter(function (p) { return !used[p.id]; }));
  }

  function reasons(p) {
    var out = [];
    var room = byKey(ROOMS, state.room);
    if (room) {
      if (state.room === 'bathroom' && p.water) out.push('Water-resistant and suitable for bathrooms');
      else if (state.room === 'kitchen' && p.water) out.push('Water-resistant – shrugs off kitchen spills');
      else out.push('Recommended for ' + room.label.toLowerCase() + 's by the manufacturer');
    }
    var d = byKey(DESIGNS, p.design), sh = byKey(SHADES, p.shade);
    if (d || sh) out.push([d ? d.label + ' design' : '', sh ? sh.label.toLowerCase() + ' tones' : ''].filter(Boolean).join(' in '));
    if (state.budget && state.budget !== 'any') out.push(money(p.ppm) + '/m² – inside your budget');
    if (state.purpose === 'noise' && p.underlay) out.push('Built-in underlay for a quieter floor');
    if (state.purpose === 'clean' && p.pet) out.push('Pet-friendly, easy-clean surface');
    if ((state.purpose === 'damaged' || state.room === 'hallway') && p.wear) out.push(p.wear + ' wear layer for heavy footfall');
    if (p.ufh) out.push('Suitable for underfloor heating');
    if (p.warranty) out.push(p.warranty + ' warranty');
    return out.filter(function (v, i, a) { return v && a.indexOf(v) === i; }).slice(0, 4);
  }

  function estimate(p) {
    var a = area();
    if (!a) return null;
    var need = a * (1 + WASTAGE);
    var packs = Math.ceil(need / p.pack);
    return { packs: packs, m2: Math.round(packs * p.pack * 100) / 100, total: packs * p.price, area: a };
  }

  /* ------------------------------------------------------------------ */
  /* Icons                                                               */
  /* ------------------------------------------------------------------ */
  var ICONS = {
    any: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14M12 17h.01" />',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5" />',
    arrow: '<path d="M4 12h16M14 6l6 6-6 6" />',
    back: '<path d="M20 12H4M10 6l-6 6 6 6" />'
  };
  function icon(name, size) {
    return '<svg viewBox="0 0 24 24" width="' + (size || 22) + '" height="' + (size || 22) + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }
  var ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];
  var ROMAN_LOW = ['i.', 'ii.', 'iii.', 'iv.', 'v.', 'vi.', 'vii.', 'viii.'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function pic(src, w, alt, cls) {
    return '<img class="ff-fade' + (cls ? ' ' + cls : '') + '" src="' + esc(img(src, w)) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async">';
  }

  /* ------------------------------------------------------------------ */
  /* Rendering                                                           */
  /* ------------------------------------------------------------------ */
  function renderSidebar() {
    var html = STEPS.map(function (s, i) {
      var done = answered(s.id) && (state.view !== 'quiz' || i < state.step);
      var current = state.view === 'quiz' && i === state.step;
      var canJump = answered(s.id) || i <= state.step || state.view !== 'quiz';
      var lbl = answerLabel(s.id);
      return '<li class="ff-index__item' + (done ? ' is-done' : '') + (current ? ' is-current' : '') + '">' +
        '<button type="button" data-ff-jump="' + i + '"' + (canJump ? '' : ' disabled') + (current ? ' aria-current="step"' : '') + '>' +
        '<span class="ff-index__no">' + ROMAN[i] + '</span>' +
        '<span class="ff-index__name">' + esc(s.short) + '</span>' +
        '<span class="ff-index__ans">' + (lbl ? esc(lbl) : '&nbsp;') + '</span>' +
        '</button></li>';
    }).join('');
    stepsEl.innerHTML = html;
    var doneCount = STEPS.filter(function (s, i) { return state.view !== 'quiz' ? true : i < state.step; }).length;
    var bar = root.querySelector('[data-ff-bar]');
    if (bar) bar.style.width = Math.round((doneCount / STEPS.length) * 100) + '%';
    restartBtn.hidden = !(state.room || state.view !== 'quiz');
  }

  function stepHeader(i, s) {
    return '<header class="ff-chapter">' +
      '<p class="ff-chapter__kicker"><span>Chapter ' + ROMAN[i] + '</span><i aria-hidden="true"></i><span>' + esc(s.short) + '</span></p>' +
      '<h2 class="ff-chapter__title">' + esc(s.title) + '</h2>' +
      '<p class="ff-chapter__sub">' + esc(s.sub) + '</p></header>';
  }

  function nav(i, canNext, nextLabel) {
    var dots = STEPS.map(function (s, j) {
      return '<i class="' + (j < i ? 'is-done' : (j === i ? 'is-current' : '')) + '"></i>';
    }).join('');
    return '<div class="ff-nav">' +
      (i > 0 ? '<button type="button" class="ff-nav__back" data-ff-back>' + icon('back', 18) + '<span>Previous</span></button>' : '<span class="ff-nav__back is-empty"></span>') +
      '<div class="ff-nav__dots" aria-hidden="true">' + dots + '</div>' +
      '<button type="button" class="ff-btn" data-ff-next' + (canNext ? '' : ' disabled') + '><span>' + esc(nextLabel || 'Continue') + '</span>' + icon('arrow', 18) + '</button>' +
      '</div>';
  }

  function countText(n) { return n + (n === 1 ? ' floor' : ' floors'); }
  function radio() { return '<span class="ff-radio" aria-hidden="true">' + icon('check', 12) + '</span>'; }

  // Pick a photo of the requested kind ('room' set or top-down 'floor' shot) from the pool, never mixing kinds
  function photo(pool, filterFn, kind, used) {
    for (var i = 0; i < pool.length; i++) {
      var p = pool[i];
      if (!filterFn(p)) continue;
      var src = kind === 'room' ? p.room : (p.floorSure ? p.floor : null);
      if (src && !(used && used[src])) { if (used) used[src] = 1; return src; }
    }
    return '';
  }

  function tile(opts) {
    return '<button type="button" class="ff-tile' + (opts.sel ? ' is-selected' : '') + (opts.cls ? ' ' + opts.cls : '') + '" data-ff-pick="' + opts.step + '" data-ff-value="' + esc(opts.value) + '" aria-pressed="' + !!opts.sel + '">' +
      '<span class="ff-tile__frame">' +
        (opts.src ? pic(opts.src, 700) : '<span class="ff-tile__blank">' + icon('any', 34) + '</span>') +
      '</span>' +
      '<span class="ff-tile__cap">' +
        (opts.flag ? '<em class="ff-tile__flag">' + esc(opts.flag) + '</em>' : '') +
        '<span class="ff-tile__row"><span class="ff-tile__no">' + esc(opts.no) + '</span><strong>' + esc(opts.label) + '</strong>' + radio() + '</span>' +
        '<small>' + esc(opts.sub) + '</small>' +
        (opts.count != null ? '<span class="ff-tile__count">' + countText(opts.count) + '</span>' : '') +
      '</span></button>';
  }

  function renderRoom(i, s) {
    var pool = poolBefore(i);
    var used = {};
    var n0 = 0;
    var tiles = ROOMS.map(function (r) {
      var n = countFor(pool, 'room', r.k);
      if (!n) return '';
      var src = (cfg.roomImages && cfg.roomImages[r.k]) || '';
      if (!src) {
        var inRoom = function (p) { return p.rooms.indexOf(r.k) > -1; };
        if (r.k === 'bathroom') src = photo(pool, function (p) { return inRoom(p) && p.design === 'tile'; }, 'room', used) || photo(pool, function (p) { return inRoom(p) && p.water; }, 'room', used);
        else src = photo(pool.slice(ROOMS.indexOf(r) * 2), inRoom, 'room', used) || photo(pool, inRoom, 'room', used);
      }
      n0++;
      return tile({ step: 'room', value: r.k, sel: isSelected('room', r.k), src: src, no: pad(n0), label: r.label, sub: r.sub });
    }).join('');
    return stepHeader(i, s) + '<div class="ff-grid ff-grid--4">' + tiles + '</div>' + nav(i, answered('room'));
  }

  function renderType(i, s) {
    var pool = poolBefore(i);
    var wet = state.room === 'bathroom' || state.room === 'kitchen';
    var used = {};
    var n0 = 0;
    var tiles = TYPES.map(function (t) {
      var n = countFor(pool, 'type', t.k);
      if (!n) return '';
      var src = photo(pool, function (p) { return p.type === t.k; }, 'room', used) || photo(products, function (p) { return p.type === t.k; }, 'room', used);
      var rec = wet && (t.k === 'LVT' || t.k === 'SPC');
      n0++;
      return tile({ step: 'type', value: t.k, sel: isSelected('type', t.k), src: src, no: pad(n0), label: t.label, sub: t.sub, count: n,
        flag: rec ? 'Recommended for ' + byKey(ROOMS, state.room).label.toLowerCase() + 's' : '' });
    }).join('');
    tiles += tile({ step: 'type', value: 'any', sel: isSelected('type', 'any'), src: '', no: pad(n0 + 1), label: 'I don\'t mind', sub: 'Show me every type', count: pool.length, cls: 'ff-tile--any' });
    return stepHeader(i, s) + '<div class="ff-grid ff-grid--3">' + tiles + '</div>' + nav(i, answered('type'));
  }

  function ledgerRow(opts) {
    return '<button type="button" class="ff-row' + (opts.sel ? ' is-selected' : '') + '" data-ff-pick="' + opts.step + '" data-ff-value="' + esc(opts.value) + '"' + (opts.disabled ? ' disabled' : '') + ' aria-pressed="' + !!opts.sel + '">' +
      '<span class="ff-row__no">' + esc(opts.no) + '</span>' +
      '<span class="ff-row__main"><strong>' + esc(opts.main) + '</strong><small>' + esc(opts.sub) + '</small></span>' +
      radio() + '</button>';
  }

  // Room size can be given as width × length, or as one total area in m²
  function sizeToggle() {
    var m = state.sizeMode === 'area' ? 'area' : 'dims';
    return '<div class="ff-size-toggle" role="group" aria-label="How would you like to enter your room size?">' +
      '<button type="button" data-ff-sizemode="dims" class="' + (m === 'dims' ? 'is-active' : '') + '" aria-pressed="' + (m === 'dims') + '">Width × length</button>' +
      '<button type="button" data-ff-sizemode="area" class="' + (m === 'area' ? 'is-active' : '') + '" aria-pressed="' + (m === 'area') + '">Total m²</button>' +
      '</div>';
  }
  function sizeLine() {
    var a = area();
    if (state.sizeMode === 'area') {
      return '<div class="ff-sentence__line"><span>My room is</span>' +
        '<label class="ff-inline ff-inline--area"><input type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + esc(state.area) + '" data-ff-size="area" aria-label="Total floor area in square metres"><span class="ff-inline__unit">m²</span><span class="ff-inline__label">Total area</span></label>' +
        '<span>in total</span><span class="ff-sentence__area" data-ff-area></span></div>';
    }
    return '<div class="ff-sentence__line"><span>My room measures</span>' +
      '<label class="ff-inline"><input type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + esc(state.width) + '" data-ff-size="width" aria-label="Width in metres"><span class="ff-inline__unit">m</span><span class="ff-inline__label">Width</span></label>' +
      '<span>by</span>' +
      '<label class="ff-inline"><input type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + esc(state.length) + '" data-ff-size="length" aria-label="Length in metres"><span class="ff-inline__unit">m</span><span class="ff-inline__label">Length</span></label>' +
      '<span class="ff-sentence__area" data-ff-area>' + (a ? '= ' + a + ' m²' : '') + '</span></div>';
  }

  function renderBudget(i, s) {
    var pool = poolBefore(i);
    var a = area();
    var rows = BUDGETS.map(function (b, j) {
      var n = countFor(pool, 'budget', b.k);
      var t = budgetText(b, a);
      return ledgerRow({ step: 'budget', value: b.k, sel: isSelected('budget', b.k), disabled: !n, no: ROMAN_LOW[j], main: t.main, sub: (t.sub ? t.sub + ' · ' : '') + n + ' floors in range' });
    }).join('');
    rows += ledgerRow({ step: 'budget', value: 'any', sel: isSelected('budget', 'any'), no: ROMAN_LOW[BUDGETS.length], main: 'I don\'t know my budget', sub: 'We\'ll show prices per m²' });
    return stepHeader(i, s) +
      '<div class="ff-sentence">' +
        '<span class="ff-sentence__label">Your room size</span>' +
        sizeToggle() + sizeLine() +
        '<p class="ff-sentence__hint">We use this to price your whole floor – packs and 10% wastage included.</p>' +
      '</div>' +
      '<p class="ff-ledger-title">' + (a ? 'Budget for your room' : 'Budget') + '</p>' +
      '<div class="ff-ledger" data-ff-budgets>' + rows + '</div>' + nav(i, answered('budget'));
  }

  function chip(opts) {
    return '<button type="button" class="ff-chip' + (opts.sel ? ' is-selected' : '') + (opts.cls ? ' ' + opts.cls : '') + '" data-ff-pick="' + opts.step + '" data-ff-value="' + esc(opts.value) + '" aria-pressed="' + !!opts.sel + '">' +
      '<span class="ff-chip__swatch">' + opts.visual + '<span class="ff-chip__tick">' + icon('check', 14) + '</span></span>' +
      '<strong>' + esc(opts.label) + '</strong><small>' + esc(opts.sub) + '</small>' +
      '<span class="ff-chip__count">' + countText(opts.count) + '</span></button>';
  }
  var BLANK = '<span class="ff-chip__blank">' + icon('any', 30) + '</span>';

  function renderPattern(i, s) {
    var pool = poolBefore(i);
    var used = {};
    var tiles = DESIGNS.map(function (d) {
      var n = countFor(pool, 'pattern', d.k);
      if (!n) return '';
      var src = photo(pool, function (p) { return p.design === d.k; }, 'floor', used) || photo(products, function (p) { return p.design === d.k; }, 'floor', used);
      return chip({ step: 'pattern', value: d.k, sel: isSelected('pattern', d.k), label: d.label, sub: d.sub, count: n, visual: src ? pic(src, 400) : BLANK });
    }).join('');
    tiles += chip({ step: 'pattern', value: 'any', sel: isSelected('pattern', 'any'), label: 'I don\'t mind', sub: 'Show me every pattern', count: pool.length, cls: 'ff-chip--any', visual: BLANK });
    return stepHeader(i, s) + '<div class="ff-grid ff-grid--chips">' + tiles + '</div>' + nav(i, answered('pattern'));
  }

  function renderShade(i, s) {
    var pool = poolBefore(i);
    var tiles = SHADES.map(function (c) {
      var n = countFor(pool, 'shade', c.k);
      if (!n) return '';
      var fan = pool.filter(function (p) { return p.shade === c.k && p.floorSure; });
      if (fan.length < 3) fan = fan.concat(products.filter(function (p) { return p.shade === c.k && p.floorSure && fan.indexOf(p) < 0; }));
      var sw = fan.slice(0, 3).map(function (p) { return pic(p.floor, 300); }).join('');
      return chip({ step: 'shade', value: c.k, sel: isSelected('shade', c.k), label: c.label, sub: c.sub, count: n, cls: 'ff-chip--fan',
        visual: sw ? '<span class="ff-fan">' + sw + '</span>' : BLANK });
    }).join('');
    tiles += chip({ step: 'shade', value: 'any', sel: isSelected('shade', 'any'), label: 'I\'m not sure', sub: 'Help me decide', count: pool.length, cls: 'ff-chip--any', visual: BLANK });
    return stepHeader(i, s) + '<div class="ff-grid ff-grid--chips">' + tiles + '</div>' + nav(i, answered('shade'));
  }

  function renderPurpose(i, s) {
    var rows = PURPOSES.map(function (p, j) {
      return ledgerRow({ step: 'purpose', value: p.k, sel: isSelected('purpose', p.k), no: ROMAN_LOW[j], main: p.label, sub: p.sub });
    }).join('');
    return stepHeader(i, s) + '<div class="ff-ledger">' + rows + '</div>' + nav(i, answered('purpose'), 'Reveal my floor');
  }

  function renderSummary() {
    var n = finalPool().length;
    var rows = STEPS.map(function (s, i) {
      return '<li><span class="ff-toc__no">' + ROMAN[i] + '</span><span class="ff-toc__name">' + esc(s.short) + '</span><span class="ff-toc__dots"></span><span class="ff-toc__ans">' + esc(answerLabel(s.id)) + '</span></li>';
    }).join('');
    return '<div class="ff-page">' +
      '<p class="ff-chapter__kicker"><span>The final chapter</span></p>' +
      '<h2 class="ff-display">We\'ve found <em>the one.</em></h2>' +
      '<p class="ff-chapter__sub">Out of our whole collection, <strong>' + n + '</strong> ' + (n === 1 ? 'floor fits' : 'floors fit') + ' your story – and one stands out.</p>' +
      '<p class="ff-page__label">Your story so far</p>' +
      '<ol class="ff-toc">' + rows + '</ol>' +
      '<div class="ff-page__actions"><button type="button" class="ff-btn ff-btn--lg" data-ff-results><span>Reveal my floor</span>' + icon('arrow', 18) + '</button>' +
      '<button type="button" class="ff-textlink" data-ff-jump="0">Edit my answers</button></div>' +
      '</div>';
  }

  function priceBlock(p, big) {
    var save = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
    return '<div class="ff-price' + (big ? ' ff-price--big' : '') + '"><strong>' + money(p.ppm) + '</strong><span>/ m²</span>' +
      (save ? '<s>' + money(p.cppm) + '</s><b class="ff-save">−' + save + '%</b>' : '') + '</div>';
  }

  function sampleBtn(p, cls) {
    if (!p.sample) return '';
    return '<button type="button" class="' + (cls || 'ff-textlink') + '" data-ff-sample="' + p.sample + '" data-title="' + esc(p.title) + '" data-vendor="' + esc(p.vendor) + '">Order free sample</button>';
  }

  function card(p) {
    var e = estimate(p);
    return '<article class="ff-card">' +
      '<a href="' + esc(p.url) + '" class="ff-card__img">' + pic(p.floor, 500, p.title) +
      (p.room ? pic(p.room, 500, '', 'ff-card__hover') : '') + '</a>' +
      '<div class="ff-card__body"><p class="ff-meta">' + esc(p.vendor) + ' · ' + esc(p.type) + '</p>' +
      '<h4><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h4>' + priceBlock(p) +
      (e ? '<p class="ff-est">' + money(e.total) + ' est. for your room</p>' : '<p class="ff-est">' + money(p.price) + ' per pack · ' + p.pack + ' m²</p>') +
      '<div class="ff-card__links"><a class="ff-textlink" href="' + esc(p.url) + '">View floor</a>' + sampleBtn(p, 'ff-textlink ff-textlink--coral') + '</div></div></article>';
  }

  function renderResults() {
    var list = ranked();
    if (!list.length) {
      return '<div class="ff-page"><h2 class="ff-display">Nothing quite fits – <em>yet.</em></h2><p class="ff-chapter__sub">Try loosening one of your answers.</p>' +
        '<div class="ff-page__actions"><button type="button" class="ff-btn" data-ff-jump="0"><span>Edit my answers</span>' + icon('arrow', 18) + '</button></div></div>';
    }
    var hero = list[0], more = list.slice(1, 4), rest = list.slice(4);
    var e = estimate(hero);
    var why = reasons(hero).map(function (r, j) { return '<li><span>' + pad(j + 1) + '</span>' + esc(r) + '</li>'; }).join('');
    var specs = [hero.width && 'Width ' + hero.width, hero.length && 'Length ' + hero.length, hero.thickness && 'Thickness ' + hero.thickness, hero.wear && 'Wear layer ' + hero.wear].filter(Boolean)
      .map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('');
    var html = '<header class="ff-chapter ff-chapter--results">' +
      '<p class="ff-chapter__kicker"><span>Your floor</span><i aria-hidden="true"></i><span>' + list.length + ' matched</span></p>' +
      '<h2 class="ff-display">Written for <em>your story.</em></h2></header>' +
      '<section class="ff-feature">' +
      '<a class="ff-feature__img" href="' + esc(hero.url) + '">' + pic(hero.room || hero.floor, 1100, hero.title) + '</a>' +
      '<div class="ff-feature__body">' +
      '<p class="ff-feature__no"><i></i>Your top match</p>' +
      '<p class="ff-meta">' + esc(hero.vendor) + ' · ' + esc(hero.type) + '</p>' +
      '<h3 class="ff-feature__title"><a href="' + esc(hero.url) + '">' + esc(hero.title) + '</a></h3>' + priceBlock(hero, true) +
      '<div class="ff-feature__est">' + (e ? '<strong>' + money(e.total) + '</strong><span>estimated for your ' + e.area + ' m² room · ' + e.packs + ' packs (' + e.m2 + ' m²) incl. ' + Math.round(WASTAGE * 100) + '% wastage</span>'
        : '<strong>' + money(hero.price) + '</strong><span>per pack · covers ' + hero.pack + ' m²</span>') + '</div>' +
      (specs ? '<ul class="ff-feature__specs">' + specs + '</ul>' : '') +
      '<p class="ff-page__label">Why we chose it for you</p><ol class="ff-feature__why">' + why + '</ol>' +
      '<div class="ff-feature__actions"><a class="ff-btn" href="' + esc(hero.url) + '"><span>View this floor</span>' + icon('arrow', 18) + '</a>' + sampleBtn(hero, 'ff-btn ff-btn--ghost') + '</div>' +
      '</div></section>';

    if (more.length) {
      html += '<div class="ff-more-head"><div><p class="ff-chapter__kicker"><span>From your shortlist</span></p><h3 class="ff-h3">' + (more.length === 1 ? 'One more' : (more.length === 2 ? 'Two more' : 'Three more')) + ' worth a closer look</h3></div>' +
        '<button type="button" class="ff-textlink" data-ff-restart-inline>Start a new story</button></div>' +
        '<div class="ff-cards">' + more.map(card).join('') + '</div>';
    }
    if (rest.length) {
      var shown = rest.slice(0, state.shown);
      html += '<div class="ff-all" data-ff-all' + (state.showAll ? '' : ' hidden') + '><div class="ff-cards">' + shown.map(card).join('') + '</div>' +
        (rest.length > shown.length ? '<div class="ff-center"><button type="button" class="ff-btn ff-btn--ghost" data-ff-more><span>Show more</span><small>' + (rest.length - shown.length) + ' left</small></button></div>' : '') + '</div>';
      if (!state.showAll) html += '<div class="ff-center"><button type="button" class="ff-btn ff-btn--ghost" data-ff-showall><span>View all ' + list.length + ' matches</span>' + icon('arrow', 18) + '</button></div>';
    }
    return html;
  }

  var renderers = { room: renderRoom, type: renderType, budget: renderBudget, pattern: renderPattern, shade: renderShade, purpose: renderPurpose };

  function markLoaded(scope) {
    (scope || root).querySelectorAll('img.ff-fade:not(.is-loaded)').forEach(function (im) {
      if (im.complete && im.naturalWidth) im.classList.add('is-loaded');
    });
  }
  // Fade images in as they arrive instead of popping
  root.addEventListener('load', function (e) { if (e.target.classList && e.target.classList.contains('ff-fade')) e.target.classList.add('is-loaded'); }, true);
  root.addEventListener('error', function (e) { if (e.target.classList && e.target.classList.contains('ff-fade')) e.target.classList.add('is-loaded'); }, true);

  function render(scroll) {
    reconcile();
    var html;
    if (state.view === 'summary') html = renderSummary();
    else if (state.view === 'results') html = renderResults();
    else html = renderers[STEPS[state.step].id](state.step, STEPS[state.step]);
    main.innerHTML = '<div class="ff-panel ff-panel--' + (state.view === 'quiz' ? STEPS[state.step].id : state.view) + '">' + html + '</div>';
    markLoaded(main);
    root.classList.toggle('is-results', state.view === 'results');
    renderSidebar();
    save();
    if (scroll) {
      var anchor = root.querySelector('[data-ff-anchor]') || root;
      var top = anchor.getBoundingClientRect().top + window.pageYOffset - 140;
      if (Math.abs(window.pageYOffset - top) > 60) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  // Cross-fade between screens: the current one eases out, then the next eases in
  function transition(change) {
    if (busy) return;
    busy = true;
    var panel = main.querySelector('.ff-panel');
    if (panel) panel.classList.add('is-leaving');
    wait(panel ? LEAVE_MS : 0).then(function () {
      change();
      render(true);
      busy = false;
    });
  }

  // Update the selection marks in place – no re-render, so nothing flashes
  function syncSelection(stepId) {
    main.querySelectorAll('[data-ff-pick="' + stepId + '"]').forEach(function (el) {
      var on = isSelected(stepId, el.getAttribute('data-ff-value'));
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on);
    });
    var nextBtn = main.querySelector('[data-ff-next]');
    if (nextBtn) nextBtn.disabled = !answered(stepId);
    renderSidebar();
    save();
  }

  /* ------------------------------------------------------------------ */
  /* Interaction                                                         */
  /* ------------------------------------------------------------------ */
  function pick(stepId, value) {
    if (busy) return;
    if (MULTI[stepId]) {
      var arr = state[stepId].slice();
      if (value === 'any') arr = arr.indexOf('any') > -1 ? [] : ['any'];
      else {
        arr = arr.filter(function (v) { return v !== 'any'; });
        var at = arr.indexOf(value);
        if (at > -1) arr.splice(at, 1); else arr.push(value);
      }
      state[stepId] = arr;
    } else if (stepId === 'type') {
      state.type = [value];
    } else {
      state[stepId] = value;
    }
    track('floor_finder_answer', { ff_step: stepId, ff_value: Array.isArray(state[stepId]) ? state[stepId].join('|') : state[stepId] });
    syncSelection(stepId);
    if (AUTO[stepId] && state.view === 'quiz') {
      var stepAt = state.step;
      setTimeout(function () { if (state.step === stepAt && state.view === 'quiz') next(); }, AUTO_MS);
    }
  }

  function next() {
    if (state.view !== 'quiz') return;
    if (!answered(STEPS[state.step].id)) return;
    if (state.step < STEPS.length - 1) transition(function () { state.step++; });
    else transition(function () { state.view = 'summary'; track('floor_finder_complete', { ff_matches: finalPool().length }); });
  }

  function back() {
    if (state.view === 'quiz' && state.step > 0) transition(function () { state.step--; });
  }

  function restart() {
    transition(function () { state = blankState(); });
    track('floor_finder_restart');
  }

  function toast(msg) {
    toastEl.innerHTML = msg;
    toastEl.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { toastEl.hidden = true; }, 5000);
  }

  function addSample(btn) {
    var id = Number(btn.getAttribute('data-ff-sample'));
    if (!id) return;
    var limitEl = document.getElementById('js-sample-limit');
    var limit = limitEl ? parseInt(limitEl.getAttribute('data-sample-limit'), 10) : 0;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(cfg.cartJsUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var samples = (cart.items || []).filter(function (it) { return it.properties && it.properties._isSample; });
      if (samples.some(function (it) { return it.variant_id === id; })) throw { msg: 'That sample is already in your basket.' };
      if (limit && samples.length >= limit) throw { msg: 'You can order up to ' + limit + ' free samples at a time.' };
      return fetch(cfg.cartAddUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { 'Sample of': btn.getAttribute('data-title'), 'Vendor': btn.getAttribute('data-vendor'), '_isSample': '1' } }] })
      }).then(function (r) { if (!r.ok) throw { msg: 'Sorry, we couldn\'t add that sample. Please try from the product page.' }; return r.json(); });
    }).then(function () {
      btn.textContent = 'Sample added ✓';
      var drawer = document.querySelector('cart-drawer'); if (drawer && typeof drawer.refreshContentsFromServer === 'function') { drawer.refreshContentsFromServer({ shouldOpenDrawer: true }); } else { toast('Free sample added. <a href="' + esc(cfg.cartUrl) + '">View basket</a>'); }
      track('floor_finder_sample', { ff_variant: id });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      fetch(cfg.cartJsUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, .js-cart-count').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      toast(esc((err && err.msg) || 'Sorry, something went wrong.'));
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-ff-pick')) { pick(t.getAttribute('data-ff-pick'), t.getAttribute('data-ff-value')); return; }
    if (t.hasAttribute('data-ff-next')) { next(); return; }
    if (t.hasAttribute('data-ff-back')) { back(); return; }
    if (t.hasAttribute('data-ff-jump')) {
      var j = Number(t.getAttribute('data-ff-jump')) || 0;
      transition(function () { state.view = 'quiz'; state.step = j; }); return;
    }
    if (t.hasAttribute('data-ff-results')) {
      transition(function () { state.view = 'results'; state.shown = PAGE_SIZE; state.showAll = false; });
      track('floor_finder_results', { ff_matches: finalPool().length }); return;
    }
    if (t.hasAttribute('data-ff-restart') || t.hasAttribute('data-ff-restart-inline')) { restart(); return; }
    if (t.hasAttribute('data-ff-showall')) { state.showAll = true; render(false); return; }
    if (t.hasAttribute('data-ff-more')) { state.shown += PAGE_SIZE; render(false); return; }
    if (t.hasAttribute('data-ff-sample')) { e.preventDefault(); addSample(t); return; }
    if (t.hasAttribute('data-ff-sizemode')) { setSizeMode(t.getAttribute('data-ff-sizemode')); return; }
  });

  root.addEventListener('input', function (e) {
    var f = e.target.getAttribute && e.target.getAttribute('data-ff-size');
    if (!f) return;
    state[f] = e.target.value;
    save();
    updateSize();
  });

  // Update budget labels without re-rendering the inputs (keeps focus)
  function updateSize() {
    var a = area();
    var areaEl = root.querySelector('[data-ff-area]');
    if (areaEl) areaEl.textContent = a && state.sizeMode !== 'area' ? '= ' + a + ' m²' : '';
    var pool = poolBefore(state.step);
    root.querySelectorAll('[data-ff-budgets] [data-ff-value]').forEach(function (btn) {
      var b = byKey(BUDGETS, btn.getAttribute('data-ff-value'));
      if (!b) return;
      var t = budgetText(b, a);
      btn.querySelector('strong').textContent = t.main;
      btn.querySelector('small').textContent = (t.sub ? t.sub + ' · ' : '') + countFor(pool, 'budget', b.k) + ' floors in range';
    });
    var lbl = root.querySelector('[data-ff-budgets]');
    if (lbl && lbl.previousElementSibling) lbl.previousElementSibling.textContent = a ? 'Budget for your room' : 'Budget';
    renderSidebar();
  }

  // Switch between width × length and total m² without re-rendering the whole step
  function setSizeMode(mode) {
    if (state.sizeMode === mode) return;
    state.sizeMode = mode;
    save();
    var box = root.querySelector('.ff-sentence');
    if (!box) return;
    var toggle = box.querySelector('.ff-size-toggle');
    var line = box.querySelector('.ff-sentence__line');
    if (toggle) toggle.outerHTML = sizeToggle();
    if (line) line.outerHTML = sizeLine();
    var first = box.querySelector('[data-ff-size]');
    if (first) first.focus();
    updateSize();
  }

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.getAttribute && e.target.getAttribute('data-ff-size')) { e.preventDefault(); e.target.blur(); }
  });

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  renderSidebar();
  loadFeed().then(function (raw) {
    products = prepare(raw);
    if (!products.length) throw new Error('No products');
    if (state.view === 'results' || state.view === 'summary') {
      if (!finalPool().length) { state.view = 'quiz'; state.step = 0; }
    }
    render(false);
    track('floor_finder_view');
  }).catch(function (err) {
    try { sessionStorage.removeItem(FEED_KEY); } catch (e) {}
    main.innerHTML = '<div class="ff-panel ff-page"><h2 class="ff-display">Sorry – the Floor Finder <em>didn\'t load.</em></h2><p class="ff-chapter__sub">Please refresh the page, or <a href="' + esc(cfg.feedUrl) + '">browse all our flooring</a>.</p></div>';
    if (window.console) console.warn('[Floor Finder]', err);
  });
})();
